export enum PackTypeCategory {
    RING = 'Ring',
    SKEWERS = 'Skewers',
    POUCH = 'Pouch',
    PLATTER='Platter'
}